<template>
  <div class="informed_consent_box">
    <van-nav-bar fixed title="知情同意书"/>
    <div class="informed_consent_content" v-html="informedConsentInfo"></div>
    <div class="btn_footer_box">
      <van-button mini type="default">取消</van-button>
      <van-button class="config_btn" mini :disabled="Boolean(countdown)" type="warning" @click="confirmRead()">我已阅读并确认
        <span v-if="countdown">（{{ countdown }}s）</span>
      </van-button>
    </div>
  </div>
</template>
<script>
import api from "@/utils/request";

export default {
  name: "informedConsent",
  data() {
    return {
      informedConsentInfo: '',
      countdown: 5,
      timer: null,
      payRouteInfo: {}
    }
  },
  methods: {
    async onDataGet() {
      const {data: {content: informedConsentInfo}} =
          await api({
            method: 'get',
            url: '/misc-service/article/id?id=4',
          })
      this.informedConsentInfo = informedConsentInfo
      this.onTimer()
    },
    // 确定
    confirmRead() {
      if (this.countdown > 0) return false
      this.$router.push(`/registeredPayment?payType=${this.payRouteInfo.payType}&askNo=${this.payRouteInfo.askNo}&couponId=${this.payRouteInfo.couponId}&couponPrice=${this.payRouteInfo.couponPrice}&payForAnother=${this.payRouteInfo.payForAnother}`)
    },
    // 计时
    onTimer() {
      if (this.timer) clearInterval(this.timer)
      this.countdown = 5
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer)
        } else {
          this.countdown--
        }
      }, 1000)
    },
    onClickLeft() {
      this.$router.back()
    }
  },
  created() {
    this.onDataGet()
    this.payRouteInfo = this.$route.query
  }
}
</script>


<style scoped lang="scss">
.informed_consent_box {
  background: #FFFFFF;

  .informed_consent_content {
    padding: 12px;
    box-sizing: border-box;
  }

  .btn_footer_box {
    background: #FFFFFF;
    padding: 8px;
    width: 100%;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;

    .config_btn {
      margin-left: 10px;
    }

  }
}
</style>